// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1I3le","content":"Consent_content__2spvB","footer":"Consent_footer__2fE1L"};